module.exports = __webpack_public_path__ + "img/loading.885d32fa.gif";